import type {
  ClientLoaderFunctionArgs,
  LoaderFunctionArgs,
  MetaFunction,
} from 'react-router';

import { enhanceWithFilterState } from '@jane/bloom/loaders/clientLoader/filterStateManagement';
import { loadJaneGoldDetailRoute } from '@jane/bloom/loaders/routes/janeGoldDetail.server';
import { janeGoldSpecialDetailRouteMeta } from '@jane/bloom/resources/meta/routes/janeGoldSpecialDetail';
import type { RouteHandle } from '@jane/bloom/types/schemas/bloom/routeHandle';

export const handle: RouteHandle = {
  hydrate: true,
};

export const meta: MetaFunction<typeof loader> = (args) => {
  return janeGoldSpecialDetailRouteMeta(args);
};

export const clientLoader = async (args: ClientLoaderFunctionArgs) => {
  const serverLoader = await args.serverLoader<typeof loader>();
  const { filterArgs, searchCriteria } = serverLoader;
  return {
    ...serverLoader,
    availableFilters: await enhanceWithFilterState({
      filterArgs,
      searchCriteria,
    }),
  };
};
clientLoader.hydrate = true;

export const loader = async (args: LoaderFunctionArgs) =>
  loadJaneGoldDetailRoute({ args });

export { JaneGoldDetailRouteComponent as default } from '@jane/bloom/components/routes/janeGoldDetail/janeGoldDetailComponent';
